import React from "react";
import { reportClientError } from "../core/clientErrorReporter";

// Top-level ErrorBoundary. React-render-errors bubblen niet naar window.onerror
// dus we MOETEN een boundary plaatsen om ze op te vangen. Een class-component
// is hier de enige optie (componentDidCatch werkt niet in hooks).
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  // Een boundary blijft anders in de foutstand hangen, ook als de gebruiker
  // intussen via de sidebar naar een andere pagina gaat (de URL wijzigt, maar
  // de boundary rendert nog steeds het foutscherm). Met een `resetKey` die bij
  // elke navigatie verandert (location.key) herstelt hij vanzelf.
  componentDidUpdate(prevProps) {
    if (this.state.hasError && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ hasError: false });
    }
  }

  componentDidCatch(error, info) {
    reportClientError(error, { componentStack: info?.componentStack ?? "" });
  }

  handleReset = () => {
    this.setState({ hasError: false });
  };

  render() {
    if (this.state.hasError) {
      // "inline": binnen de layout (sidebar en header blijven staan), zodat de
      // gebruiker gewoon verder kan navigeren. Default: volledig scherm.
      const wrapperClass =
        this.props.variant === "inline"
          ? "page-wrapper flex items-center justify-center p-6 pt-24"
          : "flex min-h-screen items-center justify-center bg-gray-50 p-6";
      return (
        <div className={wrapperClass}>
          <div className="max-w-md rounded-lg bg-white p-8 text-center shadow-sm ring-1 ring-gray-200">
            <h1 className="text-xl font-semibold text-gray-900">
              Er ging iets mis
            </h1>
            <p className="mt-2 text-sm text-gray-600">
              Het probleem is automatisch gemeld bij ons team. Probeer de pagina
              te herladen of ga via het menu naar een andere pagina.
            </p>
            <div className="mt-6 flex justify-center gap-2">
              <button
                type="button"
                onClick={() => window.location.reload()}
                className="rounded-md bg-brand px-4 py-2 text-sm font-medium text-white hover:bg-brand-hover"
              >
                Herlaad pagina
              </button>
              <button
                type="button"
                onClick={this.handleReset}
                className="rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
              >
                Doorgaan
              </button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
